

































































































import Vue from "vue";
import Component from "vue-class-component";
import Divider from "../../components/common/Divider.vue";
import ContactForm from "../../components/client/ContactForm.vue";
@Component({
  components: {
    Divider,
    ContactForm,
  },
})
export default class Contact extends Vue {
  private mounted(): void {
    window.scrollTo(0, 0);
  }
}
